import { Box, IconButton, useTheme } from "@mui/material";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ColorModeContext, tokens } from "../../theme";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";

const Topbar = ({ setAuthToken }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.clear();
    setAuthToken("");
  };

  return (
    <Box display="flex" justifyContent="flex-end" p={2} backgroundColor={colors.primary[400]}>
      {/* ICONS */}
      <Box display="flex" gap={1}>
        <IconButton onClick={colorMode.toggleColorMode} title="Basculer Thème Clair/Sombre">
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton>
        <IconButton onClick={() => navigate("/notification")} title="Diffuser une Notification">
          <NotificationsOutlinedIcon />
        </IconButton>
        <IconButton onClick={() => navigate("/settings")} title="Paramètres Système">
          <SettingsOutlinedIcon />
        </IconButton>
        <IconButton onClick={() => navigate("/team")} title="Équipe Administrateurs">
          <PersonOutlinedIcon />
        </IconButton>
        <IconButton onClick={handleLogout} title="Déconnexion" sx={{ color: "#d32f2f" }}>
          <LogoutOutlinedIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Topbar;
